import React from 'react';
import { useIntercom } from 'react-use-intercom';

import styled from 'styled-components';

import {
  Button,
  ButtonGroup,
  Flex,
  Heading,
  type ISpotIconProps,
  LinkButton,
  Modal,
  SpotIcon,
  Text,
  spacing,
} from '@sine/sine-ui-components';

import HelpBanner from '../components/help-banner/helpBanner.component';

const phoneNumbers: Array<{ flag: ISpotIconProps['type']; number: string }> = [
  { flag: 'aus-flag', number: '+61 8 8121 5956' },
  { flag: 'aus-flag', number: '1800 00 SINE (1800 007 463)' },
  { flag: 'nz-flag', number: '+64 9 887 5531' },
  { flag: 'uk-flag', number: '+44 20 3868 4676' },
  { flag: 'us-flag', number: '+1 917 310 3522' },
  { flag: 'ca-flag', number: '+1 647 946 5609' },
];

const StyledSpotIcon = styled(SpotIcon)`
  width: 24px;
  margin-right: ${spacing(1)};
`;

const PhoneNumbersWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLinkButton = styled(LinkButton)`
  margin-right: ${spacing(2)};
`;

interface HelpModalProps {
  show: boolean;
  closeModal: () => void;
}

function HelpModal({ show, closeModal }: HelpModalProps) {
  const { show: showIntercom } = useIntercom();

  return (
    <Modal
      show={show}
      size='lg'
      onClose={closeModal}
      header='Help'
      footer={
        <ButtonGroup alignment='right'>
          <Button variant='tertiary' onClick={closeModal}>
            Close
          </Button>
        </ButtonGroup>
      }
    >
      <Flex direction='column' gap={2}>
        <Heading type='h2'>Service Status</Heading>

        <LinkButton href='https://status.sine.co/' target='_blank' variant='primary'>
          Sine service status
        </LinkButton>

        <Heading type='h2'>Contact Support</Heading>

        <ButtonGroup>
          <StyledLinkButton href='https://support.sine.co/' target='_blank' variant='primary'>
            Sine knowledge base
          </StyledLinkButton>

          <Button onClick={showIntercom} variant='secondary'>
            Live chat with us now
          </Button>
        </ButtonGroup>

        <Heading type='h2'>Contact Numbers</Heading>

        <div>
          {phoneNumbers.map(({ flag, number }) => (
            <PhoneNumbersWrapper key={flag + number}>
              <StyledSpotIcon type={flag} />
              <Text>{number}</Text>
            </PhoneNumbersWrapper>
          ))}
        </div>

        <div>
          <Heading type='h2'>Need Hardware?</Heading>
          <Text>Order a Sine Starter Pack now and get all you need to check in visitors - iPads, stand, printers.</Text>
        </div>

        <LinkButton href='https://shop.sine.co/' target='_blank' variant='primary'>
          More info
        </LinkButton>

        <HelpBanner />
      </Flex>
    </Modal>
  );
}

export default HelpModal;
